import React from 'react';
import { IconProps } from '../types';
import styles from '../Icons.module.scss';
import { getSvgDimensions } from '../utils';
import { DEFAULT_ICON_SIZE } from '../constants';

const DoneIcon: React.FC<IconProps> = ({
    size = DEFAULT_ICON_SIZE,
    width,
    height,
    color = styles.naviIconDefaultColor,
    ...restProps
}) => {
    const { svgHeight, svgWidth } = getSvgDimensions({ height, width, size });
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={svgWidth}
            height={svgHeight}
            fill="none"
            viewBox="0 0 20 20"
            {...restProps}
        >
            <path
                fill={color}
                d="M7.334 13.25l-3.5-3.5-1.167 1.167 4.667 4.667 10-10-1.167-1.167-8.833 8.833z"
            ></path>
        </svg>
    );
};

export default React.memo(DoneIcon);
